import { ProductQueryParams } from "@/types/commerce"
import { buildQueryString } from "./getQueryString"
import { setCookie, getClientCookie } from "./cookies"
import { hexToRgba } from "./colors"
import { SWIPER_BREAKPOINTS } from '@/constants/breakpoints'
import { PlaylistOptions } from '@/types/cinematics'

export const objectToParamsQuery = (obj: ProductQueryParams): string => {
  if (!obj) return ""
  if (Object.keys(obj).length === 0) {
    return ""
  }

  const queryString = Object.entries(obj)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&")

  return queryString
}


// Semantic column keys map 1:1 to viewport ranges (min-width buckets):
//   base            0–379    (falls back to xs)
//   xs              380–479  (falls back to mobile)
//   mobile          480–767
//   tablet          768–1023
//   vtablet         1024–1279
//   desktop         1280–1399
//   xxl             1400–1439
//   widescreen      1440–1599
//   xxxl            1600–1849
//   ultrawidescreen 1850–2499
//   fullhd          2500+
// Historical note: before PRO-446-era realignment, `xs` drove 0–379, `mobile`
// drove 380–479 and `tablet` covered 480–1023. Cinematic JSONs authored under
// the old semantics must migrate values (base:=xs, xs:=mobile, mobile:=tablet).
export const getBreakpoints = (columns?: PlaylistOptions['columns']) => {
  return {
    [SWIPER_BREAKPOINTS.FULLHD]: {
      slidesPerView: columns?.fullhd ?? 7,
      slidesPerGroup: Math.floor(columns?.fullhd ?? 7),
    },
    [SWIPER_BREAKPOINTS.ULTRAWIDE]: {
      slidesPerView: columns?.ultrawidescreen ?? columns?.fullhd ?? 7,
      slidesPerGroup: Math.floor(columns?.ultrawidescreen ?? columns?.fullhd ?? 7),
    },
    [SWIPER_BREAKPOINTS.XXXL]: {
      slidesPerView: columns?.xxxl ?? columns?.widescreen ?? 5,
      slidesPerGroup: Math.floor(columns?.xxxl ?? columns?.widescreen ?? 5),
    },
    [SWIPER_BREAKPOINTS.XXL]: {
      slidesPerView: columns?.xxl ?? columns?.widescreen ?? 5,
      slidesPerGroup: Math.floor(columns?.xxl ?? columns?.widescreen ?? 5),
    },
    [SWIPER_BREAKPOINTS.WIDE_SCREEN]: {
      slidesPerView: columns?.widescreen ?? 5,
      slidesPerGroup: Math.floor(columns?.widescreen ?? 5),
    },
    [SWIPER_BREAKPOINTS.DESKTOP]: {
      slidesPerView: columns?.desktop ?? 3,
      slidesPerGroup: Math.floor(columns?.desktop ?? 3),
    },
    [SWIPER_BREAKPOINTS.V_TABLET]: {
      slidesPerView: columns?.vtablet ?? 3,
      slidesPerGroup: Math.floor(columns?.vtablet ?? 3),
    },
    [SWIPER_BREAKPOINTS.TABLET]: {
      slidesPerView: columns?.tablet ?? 2,
      slidesPerGroup: Math.floor(columns?.tablet ?? 2),
    },
    [SWIPER_BREAKPOINTS.CUSTOM_576]: {
      slidesPerView: columns?.mobile ?? 2,
      slidesPerGroup: Math.floor(columns?.mobile ?? 2),
    },
    [SWIPER_BREAKPOINTS.XSMALL]: {
      slidesPerView: columns?.mobile ?? 2,
      slidesPerGroup: Math.floor(columns?.mobile ?? 2),
    },
    [SWIPER_BREAKPOINTS.XS]: {
      slidesPerView: columns?.xs ?? columns?.mobile ?? 2,
      slidesPerGroup: Math.floor(columns?.xs ?? columns?.mobile ?? 2),
    },
    [SWIPER_BREAKPOINTS.BASE]: {
      slidesPerView: columns?.base ?? columns?.xs ?? 1,
      slidesPerGroup: Math.floor(columns?.base ?? columns?.xs ?? 1),
    },
  }
}

// ... rest of existing code ...
export { buildQueryString, setCookie, getClientCookie, hexToRgba }
export { toApiError } from './errors/toApiError'
